import NavComponent from "../lib/nav_component";

export const ClosePaneComponentConfig = {
    baseHtmlClass: 'nav__pane__close',
    selector: '.nav__pane__close',
};

export class ClosePaneComponent extends NavComponent {

    static new(element, pane) {
        if (!element) { return }
        return new ClosePaneComponent(element, pane, ClosePaneComponentConfig);
    }

    constructor(id_or_element, pane, config) {
        super(id_or_element, config);
        this.pane = pane;
        this.element.addEventListener('click', (event)=>{ this.dispatchAction('closePaneClick', this) });
    }

    render() {
    }

}
